import React from "react";
import i18n from "../../../../utils/ChrI18n";
import ToggleSwitch from "../../../ToggleSwitch";
import { safeMutate } from "../../../../utils/GeneralUtils";

const CookieSection = ({ cookieData, setCookiesData }) => {

  const handleToggle = (cookieDataId) => {
    setCookiesData(prevState => {
      return safeMutate(prevState, draftCookieData => {
        draftCookieData.map((draftCookie) => {
          if(draftCookie.id === cookieDataId)
              draftCookie.enabled = !draftCookie.enabled;
        })
      })
    });
  }

  let rightContent;
  if (!cookieData.isEditable) {
    rightContent = <span className="badge-success b-r-md py-0 px-3 centered-item line-height-20">{i18n.t("feature.cookie_consent.content.Always_active_badge_text")}</span>
  } else {
    rightContent = <ToggleSwitch checked={cookieData.enabled} onChange={() => handleToggle(cookieData.id)} additionalClasses={cookieData.enabled ? "bg-accent border-transparent" : null} ariaLabel={`Enable or Disable ${cookieData.key} Cookies`} />
  }

  return (
    <div className="d-flex flex-column gap-2 bg-secondary p-4 b-r-sm">
      <div className="d-flex justify-content-between">
        <div className="text-primary font-semi-bold heading-lg">{cookieData.title}</div>
        <div>{rightContent}</div>
      </div>
      <div>{cookieData.description}</div>
    </div>
  );
}

export default CookieSection;